export const instrumentationShiftRequestUserType = {
    Sender: "Sender",
    Receiver: "Receiver",
    Manager: "Manager"
};
